import { Injectable } from '@angular/core';
import { DbRecord } from './db-record';
import { RuntimeService } from './runtime.service';
import { ArcService } from './arc.service';

@Injectable()
export class RTagGroupService {

  projectsMap = new Map<string, Map<string, Set<string>>>();
  isInitialized = false;

  constructor(
    private rs: RuntimeService,
    private arcs: ArcService
  ) { }

  projectMap(project?) {
    if (!project) {
      project = this.rs.currentProject;
    }
    let projectRTags = this.projectsMap.get(project.id);
    if (!projectRTags) {
      projectRTags = new Map<string, Set<string>>();
      this.projectsMap.set(project.id, projectRTags);
    }
    return projectRTags;
  }

  checkRecords(/* ls: DbRecord[] */) {
    /*
    let project = this.rs.currentProject;
    let projectRTags = this.projectMap(project);
    let checkLs = [];
    ls.forEach(dbr => {
      if (!projectRTags.has(dbr.id)) {
        checkLs.push(dbr.id);
        projectRTags.set(dbr.id, new Set<string>());
      }
    });
    if (!checkLs.length) {
      return;
    } */

    let obs = this.arcs.run({
      fun: 'getAllRTags',
      projectId: this.rs.currentProject.id,
    });

    obs.subscribe(resp => {
      this.projectsMap.clear();
      Object.keys(resp).forEach(k =>
        this._assignDbRecord(k, resp[k]));
        this.isInitialized = true;
       // console.log('RTAGS loaded', resp);
      });
    /*  
    console.log(`CHECK RECORDS len: ${ls.length}, firstId: ${ls[0].id}`);
    let obs = this.arcs.run({
      fun: 'getRTags',
      project: project.id,
      records: checkLs
    });
    obs.subscribe(resp => {
      resp['rtags'].forEach(tpl => {
        if (tpl[1])
          this._assignDbRecord(tpl[0],tpl[1]);
      });
    });
    return obs; */
  }
  /*
    preloadRecords(ls: DbRecord[]) {
      const step = 1111;
      this.preloadRecordsCount = ls.length;
      const obs = this.checkRecords(ls.slice(0, step));
      if (obs) {
        obs.subscribe(resp => {
          this.preloadRecords(ls.slice(step));
        });
      } else {
        this.isPreloadFinished = true;
      }
    }
  */
  getRTags(dbRecord) {
    return this.projectMap().get(dbRecord.id);
  }

  hasRTag(dbRecord, rtagId?) {
    let pm = this.projectMap();
    let dbrSet = pm.get(dbRecord.id);

    if (!dbrSet) {
      return false;
    }
    return dbrSet.has(rtagId);
  }

  private _assignDbRecord(dbRecordId: string, ls: string[]) {
    this.projectMap().set(dbRecordId, new Set<string>(ls));
  }

  saveGroup(dbRecord: DbRecord, rtagId: string, deleteLs?: string[]) {
    let project = this.rs.currentProject;
    let projectRTags = this.projectMap(project);
    let dbRecordRTags = projectRTags.get(dbRecord.id);
    let obs = this.arcs.run({
      fun: 'saveRTags',
      project: project.id,
      dbRecord: dbRecord.id,
      rtagId: rtagId,
      deleteSubtags: deleteLs
    });
    obs.subscribe(resp => this._assignDbRecord(dbRecord.id, resp['params']));
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/r-tag-group.service.ts